import {put, call} from "redux-saga/effects";
import {fromJS} from "immutable";
import * as K from "../constants/constants";

// API Calls
import {fetchObjectData} from "../api/objectData";

// Actions
import {
	fetchObjectDataError,
	fetchRealestateSuccess,
	fetchResidenceSuccess,
	fetchPremisesSuccess,
} from "../actions/actionCreators";

export function* fetchObjectDataSaga({payload}) {

	try {
		const result = yield call( ()=> fetchObjectData(payload));
		if (payload.category === K.REALESTATE) {
			yield put(fetchRealestateSuccess(fromJS(result)));
		} else if (payload.category === K.PREMISES) {
			yield put(fetchPremisesSuccess(fromJS(result)));
		} else if (payload.category === K.RESIDENCE) {
			yield put(fetchResidenceSuccess(fromJS(result)));
		}
	} catch (error) {
		yield put(fetchObjectDataError(error));
	}

}



// WEBPACK FOOTER //
// ./src/js/sagas/objectDataSaga.js